export const SET_SCENE_LOADED = 'SET_SCENE_LOADED';

export const setSceneLoaded = (loaded) => ({
  type: SET_SCENE_LOADED,
  payload: {
    loaded,
  },
});
